/* global require */
// Defines base behaviors and style, common to all pages.
import "./focus.js";
import "./has-hover.js";

// Include a polyfill for Object.assign
require("es6-object-assign").polyfill();
// Include a polyfill for Array.find
require("array.prototype.find").shim();



// WEBPACK FOOTER //
// ./src/frontend/common/page/page.js